import { render, staticRenderFns } from "./TextTemplates.vue?vue&type=template&id=fddc3098&scoped=true"
import script from "./TextTemplates.vue?vue&type=script&lang=js"
export * from "./TextTemplates.vue?vue&type=script&lang=js"
import style0 from "./TextTemplates.vue?vue&type=style&index=0&id=fddc3098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddc3098",
  null
  
)

export default component.exports